var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import Flex from "@irati/ui/src/Flex";
import history from "@irati/utils/history";
import Routes, { SETUP_TENANT } from "@irati-web/app/src/routeConfig";
import { FormattedMessage } from "@irati/utils/lang";
import Button from "@irati/ui/src/Button";
import { H3 } from "@irati/ui/src/Headings";
import { Para } from "@irati/ui/src/Labels";
import { WaitImage } from "../../styled";
import { getFirstIncompleteStep, getStepDetails } from "../../../helpers";
var NotReady = /** @class */ (function (_super) {
    __extends(NotReady, _super);
    function NotReady() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function () {
            var nestedPath = getStepDetails(getFirstIncompleteStep(_this.props.tenantOnboardingSteps)).nestedPath;
            history.push("" + Routes[SETUP_TENANT] + nestedPath);
        };
        return _this;
    }
    NotReady.prototype.render = function () {
        return (React.createElement(Flex, { direction: "column", alignItems: "flex-start" },
            React.createElement(WaitImage, null),
            React.createElement(H3, { base: true },
                React.createElement(FormattedMessage, { id: "setup_tenant.steps.invite.notready.title" })),
            React.createElement(Para, { margin: "0 0 30px 0" },
                React.createElement(FormattedMessage, { id: "setup_tenant.steps.invite.notready.text" })),
            React.createElement(Button, { onClick: this.handleClick, primary: true },
                React.createElement(FormattedMessage, { id: "setup_tenant.steps.invite.notready.button" }))));
    };
    return NotReady;
}(PureComponent));
export default NotReady;
